import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
// import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import { Button, Dropdown, NavDropdown } from "react-bootstrap";
// import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import * as React from "react";
import { Fragment } from "react";
// import logo from "../images/Logo3.PNG";
import { Link } from "react-router-dom";
import NotificationBadge from "react-notification-badge/lib/components/NotificationBadge";
import { Effect } from "react-notification-badge";
import "./NavigationBar.css";

const NavigationBar = ({
  notifications,
  notifCount,
  clearNotifCount,
  markAllAsRead,
  handleNotificationClick,
}) => {
  const notificationsReverse = [...notifications].reverse();
  // const truckerUserName = localStorage.getItem("company_name");

  return (
    <Fragment>
      <AppBar
        position="fixed"
        style={{ backgroundColor: "#ffffff", left: 260, width: "calc(100% - 260px)", boxShadow: "0 2px 4px rgba(0,0,0,0.08)"}}
      >
        {/* <Container
          // maxWidth="lg"
          style={{ backgroundColor: "#303230", width: "100%" }}
        > */}
          <Toolbar disableGutters style={{ padding: '0 24px', justifyContent: 'flex-end', alignItems: 'center', gap: '20px', minHeight: '70px' }}>
            <Box style={{ display: 'flex', alignItems: 'center', gap: '20px', height: '100%' }}>
              <NavDropdown
                onClick={clearNotifCount}
                className="mr-2 first-dropdown notification-dropdown"
                title={
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    position: 'relative',
                    width: '44px',
                    height: '44px',
                    borderRadius: '12px',
                    backgroundColor: '#f8fafc',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f1f5f9';
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#f8fafc';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                  >
                    <NotificationBadge
                      style={{ 
                        zIndex: "10000",
                        position: 'absolute',
                        top: '4px',
                        right: '4px'
                      }}
                      count={notifCount.length}
                      effect={Effect.SCALE}
                    />
                    <i 
                      className="fas fa-bell" 
                      style={{
                        color: "#1e293b",
                        fontSize: "20px",
                        fontWeight: 400,
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    ></i>
                  </div>
                }
                id="collasible-nav"
              >
              <div className="p-3" >
                <div className="d-flex align-items-center justify-content-between">
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Notifications
                  </p>
                  <Button
                    title="Mark all as read"
                    className="mark-all-as-read-btn"
                    onClick={markAllAsRead}
                  >
                    <ion-icon
                      style={{ fontSize: "30px" }}
                      name="checkmark-done-circle"
                    ></ion-icon>
                  </Button>
                </div>

                {notifications.length > 0 ? (
                  <div>
                    {notificationsReverse.map((notification, index) => (
                      <div
                        key={index}
                        style={{
                          backgroundColor: notification.clicked
                            ? "transparent"
                            : "#dee2e6",
                        }}
                        onClick={() => handleNotificationClick(notification)}
                      >
                        <NavDropdown.Item
                          style={{ fontSize: "16px" }}
                          onClick={notification.onClick}
                        >
                          <p
                            className="m-0"
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: notification.clicked ? "#6c757d" : "#000",
                            }}
                          >
                            {notification.title}
                          </p>
                          <p
                            style={{
                              whiteSpace: "pre-wrap",
                              fontSize: "14px",
                              color: notification.clicked ? "#6c757d" : "#000",
                            }}
                            className="m-0"
                          >
                            {notification.message}
                          </p>
                        </NavDropdown.Item>
                        {index !== notifications.length - 1 && (
                          <Dropdown.Divider />
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="p-2">
                    <NavDropdown.Item style={{ fontSize: "16px" }}>
                      No new Notifications
                    </NavDropdown.Item>
                  </div>
                )}
              </div>
            </NavDropdown>
              <NavDropdown
                title={
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '12px',
                    padding: '8px 16px 8px 12px',
                    borderRadius: '12px',
                    backgroundColor: '#f8fafc',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f1f5f9';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#f8fafc';
                  }}
                  >
                    <div style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      backgroundColor: '#991C1C',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#ffffff',
                      fontWeight: 600,
                      fontSize: '14px',
                      flexShrink: 0,
                      boxShadow: '0 2px 8px rgba(153, 28, 28, 0.2)'
                    }}>
                      {localStorage.getItem("company_name")
                        ? (localStorage.getItem("company_name").charAt(0) || "U").toUpperCase()
                        : "U"}
                    </div>
                    <span style={{ 
                      color: "#1e293b", 
                      fontWeight: 600, 
                      fontSize: '15px',
                      whiteSpace: 'nowrap',
                      maxWidth: '200px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      {localStorage.getItem("company_name") || "User"}
                    </span>
                    <i 
                      className="fas fa-chevron-down" 
                      style={{ 
                        fontSize: '12px', 
                        color: '#64748b',
                        marginLeft: '4px',
                        transition: 'transform 0.2s ease'
                      }}
                    ></i>
                  </div>
                }
                align="end"
              >
                <NavDropdown.Item style={{ padding: '4px 8px' }}>
                  <Link to="/edituser" style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                    <button
                      style={{
                        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                        color: "#fff",
                        width: "100%",
                        border: "none",
                        borderRadius: "999px",
                        padding: "10px 16px",
                        boxShadow: "0 6px 12px rgba(99,102,241,0.25)",
                        fontWeight: 600,
                        fontSize: '14px',
                        cursor: 'pointer'
                      }}
                    >
                      Edit User
                    </button>
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Item style={{ padding: '4px 8px' }}>
                  <Link to="/resetpass" style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                    <button
                      style={{
                        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                        color: "#fff",
                        width: "100%",
                        border: "none",
                        borderRadius: "999px",
                        padding: "10px 16px",
                        boxShadow: "0 6px 12px rgba(99,102,241,0.25)",
                        fontWeight: 600,
                        fontSize: '14px',
                        cursor: 'pointer'
                      }}
                    >
                      Reset Password
                    </button>
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Item style={{ padding: '4px 8px' }}>
                  <button
                    onClick={() => {
                      if (window.confirm("Are you sure you want to logout?")) {
                        localStorage.clear();
                        window.location = "/";
                      }
                    }}
                    style={{
                      background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                      color: "#fff",
                      width: "100%",
                      border: "none",
                      borderRadius: "999px",
                      padding: "10px 16px",
                      boxShadow: "0 6px 12px rgba(99,102,241,0.25)",
                      fontWeight: 600,
                      fontSize: '14px',
                      cursor: 'pointer'
                    }}
                  >
                    Logout
                  </button>
                </NavDropdown.Item>
              </NavDropdown>
            </Box>
          </Toolbar>
      </AppBar>
    </Fragment>
  );
};
export default NavigationBar;
